import styled from "styled-components";

interface Props {
  name: string;
  children?: React.ReactNode;
  height?: string;
}

const Container = styled.section<{ height?: string }>`
    height: ${(props) => (props.height ? props.height : "auto")};
    padding: 80px 0;
    border-bottom: 1px solid #dee2e6;

    &:last-child {
        border-bottom: none;
    }
`;

const Section = (props: Props) => {
  const { name, height, children } = props;

  return (
    <Container id={name} height={height}>
      {children}
    </Container>
  );
};

export default Section;
